import React from 'react';
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  tooltip:{
    padding: "5px",
    "& p":{
      fontSize: "14px",
      color: "#000",
      marginBottom: "5px"
    }
  },
}));


export const CustomTooltip = ({ data }) => {
    const classes = useStyles();
    
    return (
      <div className={classes.tooltip}>
          <p>Treatment Month Number:{data?.month_number}</p>
          <p>MoM Progress: {data?.total_percentage}%</p>
          <br />
          <p>Total objectives: {data?.total_objectives}</p>
          <p>Met: {data?.met}</p>
      </div>
    );
};

export const ClientDetailsTooltip = ({ data }) => {
  const classes = useStyles();
  
  return (
    <div className={classes.tooltip}>
        <p>Total Precentage: {data?.total_percentage === " " ? " - " :  parseFloat(data?.total_percentage?.toFixed(2))}</p>
        <p>Met: {data?.met === " " ? " - " :  data?.met}</p>
        <p>Total_objectives: {data?.total_objectives ?? "-"}</p>
    </div>
  );
};